export const isIframed = window.self !== window.top;

export const isIframeAdmin = (user, iframeAdminRoles) =>
  isIframed &&
  user.included?.some(
    item =>
      item.type === "role" && iframeAdminRoles.includes(item.attributes.name)
  );
